import {emptyValidator, formValidator} from "../../validators";

const stkVehTypeShipperValidationStatus ={
    svtStakeholderType:{
        validators: [emptyValidator()],
        name: "Stakeholder Type"
    },
    svtCustomerShipper:{
        validators: [emptyValidator()],
        name: "Customer Shipper"
    },
    svtStakeholder:{
        validators: [emptyValidator()],
        name: "Customer"
    },
    svtVehicleType:{
        validators: [emptyValidator()],
        name: "Vehicle Type"
    },
    svtStatus:{
        validators: [emptyValidator()],
        name: "Status"
    },
    svtActive:{
        validators: [emptyValidator()],
        name: "Active"
    },
}

export const stakeholderVehicleTypeShipperValidation= (stkVehData) => {
    return formValidator(stkVehData, stkVehTypeShipperValidationStatus);
}

const stkVehTypeCustomerValidationStatus ={
    svtStakeholderType:{
        validators: [emptyValidator()],
        name: "Stakeholder Type"
    },
    svtStakeholder:{
        validators: [emptyValidator()],
        name: "Customer"
    },
    svtVehicleType:{
        validators: [emptyValidator()],
        name: "Vehicle Type"
    },
    svtStatus:{
        validators: [emptyValidator()],
        name: "Status"
    },
    svtActive:{
        validators: [emptyValidator()],
        name: "Active"
    },
}

export const stakeholderVehicleTypeCustomerValidation= (stkVehData) => {
    return formValidator(stkVehData, stkVehTypeCustomerValidationStatus);
}

const stkVehValidationStatus ={
    stvStakeholderType:{
        validators: [emptyValidator()],
        name: "Stakeholder Type"
    },
    stvStakeholder:{
        validators: [emptyValidator()],
        name: "Stakeholder"
    },
    stvVehicle:{
        validators: [emptyValidator()],
        name: "Vehicle"
    },
    stvStatus:{
        validators: [emptyValidator()],
        name: "Status"
    },
    stvActive:{
        validators: [emptyValidator()],
        name: "Active"
    },
}

export const stakeholderVehicleValidation= (stkVehData) => {
    return formValidator(stkVehData, stkVehValidationStatus);
}
